import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ImpersonationState {
  isImpersonating: boolean
  sessionId: string | null
  tenantId: string | null
  tenantName: string | null
  tenantSlug: string | null
  startedAt: string | null
  impersonationToken: string | null

  // Actions
  startImpersonation: (data: {
    sessionId: string
    tenantId: string
    tenantName: string
    tenantSlug: string
    accessToken: string
  }) => void
  endImpersonation: () => void
  clearImpersonation: () => void
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      isImpersonating: false,
      sessionId: null,
      tenantId: null,
      tenantName: null,
      tenantSlug: null,
      startedAt: null,
      impersonationToken: null,

      startImpersonation: (data) => {
        set({
          isImpersonating: true,
          sessionId: data.sessionId,
          tenantId: data.tenantId,
          tenantName: data.tenantName,
          tenantSlug: data.tenantSlug,
          startedAt: new Date().toISOString(),
          impersonationToken: data.accessToken,
        })
      },

      endImpersonation: () => {
        set({
          isImpersonating: false,
          sessionId: null,
          tenantId: null,
          tenantName: null,
          tenantSlug: null,
          startedAt: null,
          impersonationToken: null,
        })
      },

      clearImpersonation: () => {
        set({
          isImpersonating: false,
          sessionId: null,
          tenantId: null,
          tenantName: null,
          tenantSlug: null,
          startedAt: null,
          impersonationToken: null,
        })
      },
    }),
    {
      name: 'mindmetal-impersonation',
      // Store in sessionStorage instead of localStorage for security
      // Impersonation should not persist across browser sessions
      storage: {
        getItem: (name) => {
          const str = sessionStorage.getItem(name)
          return str ? JSON.parse(str) : null
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name)
        },
      },
    }
  )
)
